export default "__VITE_ASSET__BHPBi5dA__"